"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = createOptions;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var defaultOptions = {
  firstPaint: false,
  firstContentfulPaint: true,
  firstInputDelay: true,
  useLogging: true,
  useGoogleAnalytics: false
};

function createOptions(pluginOptions) {
  return (0, _extends2["default"])({}, defaultOptions, pluginOptions);
}